package com.yendo.mx.utils

import dev.gitlive.firebase.auth.AuthCredential
import dev.gitlive.firebase.auth.GoogleAuthProvider
import kotlinx.coroutines.await
import kotlin.js.Promise

actual suspend fun nativoSignInWithGoogle(): AuthCredential? {
    return try {
        val googleAuthPromise = js("""
            (function() {
                var authModule = window.firebaseAuth || (typeof firebase !== 'undefined' ? firebase.auth : null);
                if (!authModule && typeof require !== 'undefined') {
                    try { authModule = require('firebase/auth'); } catch(e) {}
                }
                if (!authModule) {
                    return Promise.reject(new Error("Firebase Auth JS SDK no encontrado."));
                }
                var auth = authModule.getAuth ? authModule.getAuth() : (authModule.getInstance ? authModule.getInstance() : authModule());
                var provider = authModule.GoogleAuthProvider ? new authModule.GoogleAuthProvider() : new firebase.auth.GoogleAuthProvider();
                return authModule.signInWithPopup ? authModule.signInWithPopup(auth, provider) : auth.signInWithPopup(provider);
            })()
        """).unsafeCast<Promise<dynamic>>()

        val result = googleAuthPromise.await()
        val idTokenPromise = result.user.getIdToken().unsafeCast<Promise<String>>()
        val idToken = idTokenPromise.await()
        GoogleAuthProvider.credential(idToken, null)
    } catch (e: Throwable) {
        println("YENDO_WEB: Error en nativoSignInWithGoogle -> ${e.message}")
        null
    }
}

actual suspend fun nativoSignInWithApple(): AuthCredential? = null
actual suspend fun nativoVerifyPhoneNumber(telefono: String, contexto: Any?): String? = null
actual fun obtenerTokenFcmNativo(): String = ""
actual fun obtenerEmailSocialPendiente(): String? = null
actual fun obtenerNombreSocialPendiente(): String? = null
actual fun obtenerApellidoSocialPendiente(): String? = null
actual fun obtenerFotoSocialPendiente(): String? = null
actual fun obtenerIdTokenSocialPendiente(): String? = null
actual fun nativoLogout() {}
